import * as faker from 'faker';
import {GraphQLScalarType} from 'graphql';
import * as moment from 'moment';

export const resolvers = {
    // force ID to serialize as a number
    // per the GraphQL spec IDs should be strings
    // but the schema freely mixes `ID` and `Int` for some IDs
    ID: new GraphQLScalarType({
        name: 'ID',
        serialize: (value) => +value,
        parseValue: (value) => +value,
        parseLiteral: (ast) => +ast.value,
    }),

    Date: new GraphQLScalarType({
        name: 'Date',
        serialize: (value) => value.format('YYYY-MM-DD'),
        parseValue: (value) => moment.utc(value, moment.ISO_8601),
        parseLiteral: (ast) => moment.utc(ast.value, moment.ISO_8601),
    }),

    DateTime: new GraphQLScalarType({
        name: 'DateTime',
        serialize: (value) => value.format('YYYY-MM-DD[T]HH:mm:ss'),
        parseValue: (value) => moment.utc(value, moment.ISO_8601),
        parseLiteral: (ast) => moment.utc(ast.value, moment.ISO_8601),
    }),

    DateTimeOffset: new GraphQLScalarType({
        name: 'DateTimeOffset',
        serialize: (value) => value.format('YYYY-MM-DD[T]HH:mm:ssZZ'),
        parseValue: (value) => moment.utc(value, moment.ISO_8601),
        parseLiteral: (ast) => moment.utc(ast.value, moment.ISO_8601),
    }),

    Seconds: new GraphQLScalarType({
        name: 'Seconds',
        serialize: (value) => value.asSeconds(),
        parseValue: (value) => moment.duration(value, 'seconds'),
        parseLiteral: (ast) => moment.duration(ast.value, 'seconds'),
    }),

    Milliseconds: new GraphQLScalarType({
        name: 'Milliseconds',
        serialize: (value) => value.asMilliseconds(),
        parseValue: (value) => moment.duration(value),
        parseLiteral: (ast) => moment.duration(ast.value),
    }),
};

let currentId = faker.random.number({min: 75124, max: 65536});

export const mocks = {
    ID: () => currentId++,
    Int: () => faker.random.number({min: 1, max: 5000}),
    Float: () => faker.random.number({min: 1, max: 5000, precision: 6}),
    Decimal: () => faker.random.number({min: 1, max: 5000, precision: 2}).toFixed(2),
    String: () => faker.lorem.words(2),
    Date: () => moment.utc(faker.date.past(2)).startOf('day'),
    DateTime: () => moment.utc(faker.date.past(2)),
    DateTimeOffset: () => moment.utc(faker.date.past(2)),
    Seconds: () => moment.duration(faker.random.number({min: 2, max: 5000}), 'seconds'),
    Milliseconds: () => moment.duration(faker.random.number({min: 50, max: 20000})),
};
